module.exports = __webpack_public_path__ + "static/media/Accreditations.61619d74.jpg";